export default function UserDetails(props) {
  return (
    <p className="font-poppins pb-1 pl-3 max-lg:text-xs max-lg:pl-0 max-base:text-xs text-black text-sm">
      <span className="text-dark-blue font-semibold">{props.title} : </span>
      {props.value}
    </p>
  );
}
